/* eslint-disable jsx-a11y/role-supports-aria-props */
import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import "./index.scss";
import { checkUsername } from "../../utils/commonFunctions";

const FieldRules = styled.div`
  .field-rules-enter {
    opacity: 0.01;
    transform: scale(0.9) translateY(50%);
  }
  .field-rules-enter-active {
    opacity: 1;
    transform: scale(1) translateY(0%);
    transition: all 600ms ease-out;
  }
  .field-rules-exit {
    opacity: 1;
    transform: scale(1) translateY(0%);
  }
  .field-rules-exit-active {
    opacity: 0.01;
    transform: scale(0.9) translateY(50%);
    transition: all 600ms ease-out;
  }
`;

const userIdSuggestion = (object) =>
  object.value === true ? "Met" : "Not Met";

const UsernameValidator = ({
  username,
  checkIsUsernameValid,
  userIdExistsError,
  validationMessage
}) => {
  // Rule: 0. At least 8 characters but no more than 50.
  // Rule: 1. At least letter
  // Rule: 2. Allowed special characters: - _ @ . ;
  const illegalChars = /[^a-zA-Z0-9-_@.]/;
  const atLeastOneLetter = /[A-Za-z]+/;
  const containsIllegalChars = illegalChars.test(username);
  const isValidUsername = checkUsername(username);
  checkIsUsernameValid(isValidUsername);
  const rules = [
    {
      key: 0,
      value: username.length >= 8 && username.length <= 50,
      errormessage: "At least 8 characters but no more than 50.",
    },
    {
      key: 1,
      value: atLeastOneLetter.test(username),
      errormessage: "At least one letter.",
    },
    {
      key: 2,
      value: !containsIllegalChars,
      hide: !containsIllegalChars,
      errormessage: "Only special characters allowed are:  - _ @ . ",
    },
  ];

  const messages = rules.map((object) => (
    <Row key={object.key} className={object.hide && "d-none"}>
      <Col xs={1}>
        {object.value === true ? (
          <FontAwesomeIcon
            icon={faCheckCircle}
            aria-hidden="false"
            aria-label="UserId rule satisfied"
            className="success-icon"
          />
        ) : (
          <FontAwesomeIcon
            icon={faCheckCircle}
            aria-hidden="false"
            aria-label="UserId rule not satisfied"
            className="failure-icon"
          />
        )}
      </Col>
      <Col xs={11} className="user-test-message">
        <div
          role="alert"
          data-testid="userIdError"
          aria-label={`${userIdSuggestion(object)} ${object.errormessage}`}
          className={`mt-1 ${
            object.value === true
              ? "password-compatible"
              : "password-incompatible"
          }`}
        >
          {object.errormessage}
        </div>
      </Col>
    </Row>
  ));
  return (
    <>
      {userIdExistsError && (
        <p
          aria-live="polite"
          id="validation-error-message"
          className="form-validation-error___2YuJL"
        >
          <span className="validation-icon___3zpVI">
            <span className="icon___66GYG icon-sm___3uA1E icon-Inherit___1UF-f ">
              <svg
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                fill="currentColor"
                role="none"
                focusable="false"
                aria-hidden="true"
              >
                <path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346 7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
              </svg>
            </span>
          </span>
          <span className="validation-text___H1nk9">{validationMessage}</span>
        </p>
      )}
      <FieldRules data-testid="userIdError">
        <CSSTransition
          in={!isValidUsername}
          timeout={600}
          classNames="field-rules"
          unmountOnExit
        >
          <div>
            <TransitionGroup>
              <CSSTransition
                key={!!username.length}
                timeout={600}
                classNames="field-rules"
                unmountOnExit
              >
                {username && username.length && (
                  <div className="pt-1">{messages}</div>
                )}
              </CSSTransition>
            </TransitionGroup>
          </div>
        </CSSTransition>
      </FieldRules>
    </>
  );
};

UsernameValidator.propTypes = {
  username: PropTypes.string,
};

export default UsernameValidator;
